import { render, staticRenderFns } from "./ReportSummarySimple.vue?vue&type=template&id=1835ecae&scoped=true"
import script from "./ReportSummarySimple.vue?vue&type=script&lang=ts"
export * from "./ReportSummarySimple.vue?vue&type=script&lang=ts"
import style0 from "./ReportSummarySimple.vue?vue&type=style&index=0&id=1835ecae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1835ecae",
  null
  
)

export default component.exports